import { h } from 'preact';

// eslint-disable-next-line max-len
const ProductDetails = ({ product, isQuickView = false, specialClass, isBenefits = true, isBundlePlp }) => {
  if (!product) return false;
  const { smellsLike, feelsLike, benefits } = product;
  
  const hasFeelsLike = !isQuickView && !isBenefits && feelsLike;
  const hasSmellsLike = !isQuickView && !isBenefits && smellsLike;
  const hasBenefits = isBenefits && benefits;
  const hasBundleSmellsLike = isBundlePlp && isQuickView && smellsLike;
  
  const hasAnyContent = hasFeelsLike || hasSmellsLike || hasBenefits || hasBundleSmellsLike;
  
  if (!hasAnyContent) return null;
  
  return (
    <ul className={`${isQuickView ? 'mb-5' : 'border-t border-grey-4 mt-4'} `}>
      {hasFeelsLike && (
        <li
          className={`border-b border-grey-4 py-[18px] ${
            isQuickView ? '' : specialClass
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.feelsTitle}
          </span>
          <span className="block text-body-2">{feelsLike}</span>
        </li>
      )}
      {hasSmellsLike && (
        <li
          className={`border-b border-grey-4 py-[18px] ${
            isQuickView ? '' : specialClass
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.smellsTitle}
          </span>
          <span className="block text-body-2">{smellsLike}</span>
        </li>
      )}
      {hasBenefits && (
        <li
          className={`border-b border-grey-4 ${
            isQuickView
              ? `py-[18px] last-of-type:mb-0`
              : `py-[18px] ${specialClass}`
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.benefitsTitle}
          </span>
          <span className="block text-body-2">{benefits}</span>
        </li>
      )}
      {hasBundleSmellsLike && (
        <li
          className={`border-b border-grey-4 ${
            isQuickView
              ? `py-[18px] last-of-type:mb-0`
              : `py-[18px] ${specialClass}`
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.smellsTitle}
          </span>
          <span className="block text-body-2">{smellsLike}</span>
        </li>
      )}
    </ul>
  );
};

export default ProductDetails;
